<!-- =========================================================================================
  File Name: AttendeeList.vue
  Description: Attendee List
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<template>
  <div id="page-user-list">
    <div class="header-custome">
      <h3>
        Paid Registrations
        <span>{{
          gridSelectedRows ? "Rows Selected: " + gridSelectedRows : ""
        }}</span>
      </h3>
      <vs-button  
        v-if="prevRoute.name=='registration-dashboard'"      
        @click="$router.push('/event/reg-dashboard?activeTab=1')"
        >Go to Registration</vs-button
      >
      <div class="knowlg-base-wrap-sec">
        <a href="/pages/knowledge-base/category-attendees/question-2">
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-help-circle"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
          </span>
          Need help with this section?
        </a>
      </div>
    </div>
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="
                p-4
                border border-solid
                d-theme-border-grey-light
                rounded-full
                d-theme-dark-bg
                cursor-pointer
                flex
                items-center
                justify-between
                font-medium
              "
            >
              <span class="mr-2"
                >{{
                  currentPage * paginationPageSize - (paginationPageSize - 1)
                }}
                -
                {{
                  attendeeData.length - currentPage * paginationPageSize > 0
                    ? currentPage * paginationPageSize
                    : attendeeData.length
                }}
                of {{ attendeeData.length }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                <span>100</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <!--ADD Attendee-->

        <vs-popup
          mailpopup
          class="holamundo customnewpopup"
          title="Mail Preview"
          :active.sync="popupActiveMail"
        >
          <vs-tabs>
            <vs-tab label="Preview">
              <div class="tab-text">
                <div class="vx-row" style="width: 622px">
                  <div class="vx-col md:w-1/1 w-full mt-4">
                    <h3>Subject: {{ welcomeMailSubject }}</h3>
                  </div>
                  <br />
                  <div v-html="welcomeMailText"></div>
                  <!--<quill-editor v-model="welcomeMailText"></quill-editor>-->
                  <br />
                  <div class="vx-col md:w-1/1 w-full mt-4">
                    <div click="sendbtn-section">
                      <vs-button
                        color="rgb(76, 139, 246)"
                        type="filled"
                        @click="popupActiveMail = false"
                        >Cancel</vs-button
                      >
                      <vs-button
                        class="mail-btn"
                        color="rgb(76, 139, 246)"
                        type="filled"
                        @click="sendMail"
                        >Send Mail</vs-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </vs-tab>
            <vs-tab label="Edit">
              <div class="tab-text">
                <div class="vx-row" style="width: 622px">
                  <div class="vx-col md:w-1/1 w-full mt-4">
                    Subject:
                    <vs-input
                      class="inputx w-full mt-4"
                      v-model="welcomeMailSubject"
                      v-validate="'required'"
                      name="Subject"
                    />
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('Subject')"
                      >{{ errors.first("Subject") }}</span
                    >
                    <br />Body:
                    <vs-textarea
                      class="inputx w-full mt-4"
                      v-model="sourcehtml"
                      rows="10"
                      cols="100"
                    />
                    <br />
                    <div click="sendbtn-section">
                      <vs-button
                        color="rgb(76, 139, 246)"
                        type="filled"
                        @click="popupActiveMail = false"
                        >Cancel</vs-button
                      >
                      <vs-button
                        class="mail-btn"
                        color="rgb(76, 139, 246)"
                        type="filled"
                        @click="before_save"
                        >Save</vs-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </vs-tab>
          </vs-tabs>
        </vs-popup>

        <!--<vs-popup
          mailpopup
          class="holamundo customnewpopup"
          title="Mail Template Edit"
          :active.sync="popupActiveMailUpdate"
        >
          
        </vs-popup>-->

        <!-- <vs-button type="gradient mr-4" @click="getMailTpl">Mail Attendee(s)</vs-button> -->
        <!--<vs-button type="gradient mr-4" @click="getMailTplRaw">Edit Mail</vs-button>-->
        <!--
        <vs-button color="success" type="gradient mr-4" @click="changeStatus(true)">Active</vs-button>
        <vs-button color="danger" type="gradient mr-4" @click="changeStatus(false)">Inactive</vs-button>
        -->
        <!-- <vs-button type="gradient mr-4" v-on:click="addRecord ()">Add New</vs-button> -->

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input
          class="
            sm:mr-4
            mr-0
            sm:w-auto
            w-full
            sm:order-normal
            order-3
            sm:mt-0
            mt-4
          "
          v-model="searchQuery"
          @input="updateSearchQuery"
          placeholder="Search..."
        />
        <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

        <!-- ACTION - DROPDOWN -->
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="
              p-3
              shadow-drop
              rounded-lg
              d-theme-dark-light-bg
              cursor-pointer
              flex
              items-end
              justify-center
              text-lg
              font-medium
              w-32
            "
          >
            <span class="mr-2 leading-none">Actions</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
            <!-- <vs-dropdown-item @click="changeStatus(true)">
              <span class="flex items-center">
                <feather-icon
                  icon="ArchiveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Active</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item @click="changeStatus(false)">
              <span class="flex items-center">
                <feather-icon
                  icon="ArchiveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>InActive</span>
              </span>
            </vs-dropdown-item> -->

            <vs-dropdown-item @click="exportSelected()">
              <span class="flex items-center">
                <feather-icon
                  icon="FileIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Download CSV</span>
              </span>
            </vs-dropdown-item>

            <!-- <vs-dropdown-item @click="copySpeaker()">
              <span class="flex items-center">
                <feather-icon
                  icon="FileIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Create Speaker</span>
              </span>
            </vs-dropdown-item> -->

            <!-- <vs-dropdown-item @click="deleteRecord()">
              <span class="flex items-center">
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Delete Record(s)</span>
              </span>
            </vs-dropdown-item> -->
          </vs-dropdown-menu>
        </vs-dropdown>
        <!-- <vs-button
          color="primary"
          type="border"
          class="ml-3"
          @click="popupActive = true"
          >Import</vs-button
        > -->
        <vs-popup
          class="holamundo"
          title="Import Attendee"
          :active.sync="popupActive"
        >
          <div class="import-attendee-wrapper">
            <div class="template-download">
              <h4>Download the template</h4>
              <a
                color="primary"
                type="filled"
                class="mt-3 btn"
                href="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDownloads%2FTemplate_Attendee.xlsx?alt=media&token=af0ac634-c0d2-4034-baec-1e552285635f"
                >Download</a
              >
            </div>
            <!--
              <div class="add-content mt-5">
                <h4>Add content</h4>
                <p>Add content to the template. Please don’t delete or rename columns, leave them empty if unused.</p>
              </div>
            -->
            <div class="upload-file mt-5">
              <h4>Upload your file</h4>
              <div class="file-up-section">
                <p>Select XLSX file</p>
                <input
                  type="file"
                  id="attendee_file"
                  accept=".csv, .xlsx, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
                <vs-button
                  color="rgb(76, 139, 246)"
                  type="filled"
                  class="sub-btn"
                  v-on:click="UploadAttendee"
                  >Upload</vs-button
                >
              </div>
            </div>
          </div>
        </vs-popup>
        <!-- <vs-button
          color="primary"
          type="border"
          class="ml-3 setting-btn"
          @click="getSettings"
        >
          <img src="../../assets/images/settings.svg" alt="settings" />
        </vs-button> -->
        <!-- <vs-popup
          class="holamundo"
          title="Attendee Option"
          :active.sync="popupActive2"
        >
          <ul class="option-inner-wrap mb-5">
            <li class="mb-4">
              <label for>Allow Meeting Requests</label>
              <vs-switch v-model="settingsData.ShowMeetingButton" />
            </li>
            <li class="mb-4">
              <label for>Show Filter</label>
              <vs-switch v-model="settingsData.ShowFilter" />
            </li>
            <li class="mb-4">
              <label for>Show Send Message Button</label>
              <vs-switch v-model="settingsData.ShowSendMessageButton" />
            </li>
            <li class="mb-4">
              <label for>Show Search</label>
              <vs-switch v-model="settingsData.ShowSearch" />
            </li>
            <li class="mb-4">
              <label for>Enable Attendee DB Search</label>
              <vs-switch v-model="settingsData.EnableAttendeeDBsearch" />
            </li>
            <li class="mb-4">
              <label for>Show Email and Phone</label>
              <vs-switch v-model="settingsData.ShowEmailandPhone" />
            </li>
          </ul>
          <vs-button type="gradient" class="sub-btn" v-on:click="saveSettings"
            >Save</vs-button
          >
        </vs-popup> -->
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-full my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="attendeeData"
        rowSelection="multiple"
        rowMultiSelectWithClick="false"
        suppressRowClickSelection="true"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        @selection-changed="onSelectionChanged"
      ></ag-grid-vue>
      <h3>Total Amount: {{ totalAmount.toFixed(2) }}</h3>
      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
  </div>
</template>
<script>
//import db from "@/firebase/firebaseInit.ts";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import moment from "moment-timezone";

// Store Module
import moduleAttendeeManagement from "@/store/attendee-management/moduleAttendeeManagement.js";
import ls from "@/common/localStorage";
import bu from "@/store/bulkupload/BulkUpload.js";

// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererStatusReg from "./cell-renderer/CellRendererStatusReg.vue";
import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import CellRendererAmountReg from "./cell-renderer/CellRendererAmountReg.vue";
import CellRendererTransactionIDReg from "./cell-renderer/CellRendererTransactionIDReg.vue";
import CellRendererSourceReg from "./cell-renderer/CellRendererSourceReg.vue";
import CellRendererCreatedOnReg from "./cell-renderer/CellRendererCreatedOnReg.vue";
//console.log(db);
//const event_collectionName = 'sayek-dev';
var Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");
var eventID = ls.getSessionValueByKey("Session_Event_Id");

export default {
  components: {
    AgGridVue,
    vSelect,
    quillEditor,

    // Cell Renderer
    CellRendererLink,
    CellRendererStatusReg,
    CellRendererAmountReg,
    CellRendererTransactionIDReg,
    CellRendererSourceReg,
    CellRendererCreatedOnReg,
    CellRendererVerified,
    CellRendererActions,
  },
  data() {
    return {
      // settingsData: { ShowMeetingButton: false },
      popupActiveMail: false,
      popupActiveMailUpdate: false,
      mailRecepients: [],
      welcomeMailText: null,
      welcomeMailSubject: null,
      sourcehtml: null,
      // Filter Options
      roleFilter: { label: "All", value: "all" },
      roleOptions: [
        { label: "All", value: "all" },
        { label: "Admin", value: "admin" },
        { label: "User", value: "user" },
        { label: "Staff", value: "staff" },
      ],

      statusFilter: { label: "All", value: "all" },
      statusOptions: [
        { label: "All", value: "all" },
        { label: "Active", value: "active" },
        { label: "Deactivated", value: "deactivated" },
        { label: "Blocked", value: "blocked" },
      ],

      isVerifiedFilter: { label: "All", value: "all" },
      isVerifiedOptions: [
        { label: "All", value: "all" },
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" },
      ],

      departmentFilter: { label: "All", value: "all" },
      departmentOptions: [
        { label: "All", value: "all" },
        { label: "Sales", value: "sales" },
        { label: "Development", value: "development" },
        { label: "Management", value: "management" },
      ],
      prevRoute: null,
      searchQuery: "",
      popupActive: false,
      popupActive2: false,
      // AgGrid
      totalAmount: 0,
      gridSelectedRows: 0,
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [
        {
          headerName: "ID",
          field: "AttendeeId",
          width: 180,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          pinned: "left",
        },
        {
          headerName: "Name",
          field: "Name",
          filter: true,
          width: 200,
          pinned: "left",
        },
        {
          headerName: "Email",
          field: "Email",
          filter: true,
          width: 300,
        },
        // {
        //   headerName: "Company",
        //   field: "Company",
        //   filter: true,
        //   width: 150,
        // },
        // {
        //   headerName: "Designation",
        //   field: "Designation",
        //   filter: true,
        //   width: 150,
        // },
        {
          headerName: "Amount",
          field: "Payment.Amount",
          filter: true,
          cellRendererFramework: "CellRendererAmountReg",
        },
        {
          headerName: "Transaction ID",
          field: "Payment.TransactionId",
          filter: true,
          cellRendererFramework: "CellRendererTransactionIDReg",
        },
        {
          headerName: "Source",
          field: "Payment.Source",
          filter: true,
          cellRendererFramework: "CellRendererSourceReg",
        },

        {
          headerName: "Payment Status",
          field: "Payment.Status",
          filter: true,
          width: 150,
          cellRendererFramework: "CellRendererStatusReg",
        },
        {
          headerName: "Created On",
          field: "Payment.Created",

          cellRendererFramework: "CellRendererCreatedOnReg",
          // cellRenderer: (data) => {
          //   return data.value
          //     ? this.SetTimeByZone(
          //         new Date(data.value.seconds * 1000).toUTCString(),
          //         Session_Event_TZ
          //       )
          //     : "";
          // },
          //filter: true,
          width: 150,
        },
        // {
        //   headerName: "Actions",
        //   field: "transactions",
        //   width: 100,
        //   cellRendererFramework: "CellRendererActions",
        //   cellRendererParams: (params) => {
        //     return {
        //       id: params.data.AttendeeId,
        //       DynamicFields: params.data.DynamicFields,
        //     };
        //   },
        // },
        {
          headerName: "RSVPCode",
          field: "RSVPCode",
          filter: true,
          width: 300,
        },
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatusReg,
        CellRendererAmountReg,
        CellRendererTransactionIDReg,
        CellRendererSourceReg,
        CellRendererCreatedOnReg,
        CellRendererVerified,
        CellRendererActions,
      },
    };
  },
  watch: {
    /*roleFilter (obj) {
      this.setColumnFilter('role', obj.value)
    },
    statusFilter (obj) {
      this.setColumnFilter('status', obj.value)
    },
    isVerifiedFilter (obj) {
      const val = obj.value === 'all' ? 'all' : obj.value === 'yes' ? 'true' : 'false'
      this.setColumnFilter('is_verified', val)
    },
    departmentFilter (obj) {
      this.setColumnFilter('department', obj.value)
    }*/
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  computed: {
    attendeeData() {
      return this.$store.state.attendeeManagement.attendees;
    },
    /*usersData () {
      return this.$store.state.userManagement.users
    },*/
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    onSelectionChanged() {
      let selectedRows = this.gridApi.getSelectedRows();
      this.gridSelectedRows = selectedRows.length;
    },
    SetTimeByZone: function (strDateTime, timeZone) {
        var date;
      if (strDateTime.seconds) {
        date = moment
          .tz(strDateTime.seconds * 1000, Session_Event_TZ)
          .format("MMM DD YYYY hh:mm A");
      } else {
        date = moment
          .tz(strDateTime, Session_Event_TZ)
          .format("MMM DD YYYY hh:mm A");
      }

      return date;
    },
    getSettings() {
      this.$vs.loading();

      this.$store.dispatch("attendeeManagement/getSettings").then((res) => {
        this.settingsData = res;
        this.popupActive2 = true;
        this.$vs.loading.close();
      });
    },
    copySpeaker() {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      //console.log(selectedRows);
      if (selectedRows.length > 0) {
        this.$vs.loading();
        this.$store
          .dispatch("attendeeManagement/copySpeakerFromAttendee", selectedRows)
          .then((res) => {
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Create Speaker",
              text: res.message,
            });
            this.$vs.loading.close();
          });
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Create Speaker",
          text: "Please select atleast one attendee to create speaker. ",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    exportSelected() {
      let selectedRows;
      debugger;
      selectedRows = this.gridApi.getSelectedRows();
      //console.log(selectedRows);
      if (selectedRows.length > 0) {
        this.popupActiveExport = true;
        var datarowh = [];
        let cellIndex = [];
        let DynamicFieldsIndex = 4;
        let DynamicFieldsStartIndex = 4;

        datarowh.push("Salutation");
        datarowh.push("Name");
        datarowh.push("Email");
        datarowh.push("Phone");
        datarowh.push("Company");
        datarowh.push("Title");
        datarowh.push("MailingAddress");
        datarowh.push("Country");
        datarowh.push("State");
        datarowh.push("City");
        datarowh.push("ZIP");

        //---------------------------
        datarowh.push("Payment Status");
        datarowh.push("Transaction ID");
        datarowh.push("Amount");
        datarowh.push("Date");
        datarowh.push("Channel");
        datarowh.push("RegistrationType");
        datarowh.push("PaymentRetryURL");
        datarowh.push("RSVPCode");

        var AttendeeData = [];
        let Header = [];
        let Data = [];

        selectedRows.filter((row) => {
          if (row.DynamicFields) {
            let DynamicFields = Object.values(row.DynamicFields);
            DynamicFields.filter(function (rowfeild) {
              if (rowfeild.label) {
                let label = rowfeild.label.replace(",", "-");
                if (!datarowh.includes(label)) {
                  cellIndex.push({
                    index: DynamicFieldsIndex,
                    label: label,
                    value: rowfeild.value,
                  });
                  datarowh.push(label);
                  DynamicFieldsIndex++;
                }
              }
            });
          }
        });
        var customDomain = ls.getSessionValueByKey("CustomDomain");
        customDomain = "https://" + ls.getSessionValueByKey("CustomDomain");
        // alert(customDomain);

        selectedRows.map((row) => {

          //---------------------------------------------------------
          let datarowv = [];
          var salutation = "";
          salutation = row.Salutation == undefined ? "" : row.Salutation;
          datarowv.push(salutation);
          var name = "";
          name = row.Name == undefined ? "" : row.Name;
          datarowv.push(
            name.replace("#", "").replace("#", "").replace("#", "")
          );

          var Email = "";
          Email = row.Email == undefined ? "" : row.Email;
          datarowv.push(
            Email.replace("#", "").replace("#", "").replace("#", "")
          );

          var Phone = "";
          Phone = row.Phone == undefined ? "" : row.Phone;
          datarowv.push(
            Phone.replace("#", "").replace("#", "").replace("#", "")
          );

          var Company = "";
          Company = row.Company == undefined ? "" : row.Company;
          datarowv.push(
            Company.replace("#", "")
              .replace("#", "")
              .replace("#", "")
              .replace("#", "")
              .replace(/[, ]+/g, " ")
              .replace(/#(\S)/g, " ")
          );

          var Designation = "";
          Designation = row.Designation == undefined ? "" : row.Designation;
          datarowv.push(
            Designation.replace("#", "")
              .replace("#", "")
              .replace("#", "")
              .replace(/[, ]+/g, " ")
              .replace(/#(\S)/g, " ")
          );

          var MailingAddress = "";
          MailingAddress =
            row.MailingAddress == undefined ? "" : row.MailingAddress;
          datarowv.push(
            MailingAddress.replace("#", "")
              .replace("#", "")
              .replace("#", "")
              .replace("#", "")
              .replace("#", "")
              .replace(/[, ]+/g, " ")
              .replace(/#(\S)/g, " ")
          );

          var Country = "";
          Country = row.Country == undefined ? "" : row.Country;
          datarowv.push(
            Country.replace("#", "")
              .replace("#", "")
              .replace("#", "")
              .replace(/[, ]+/g, " ")
              .replace(/#(\S)/g, " ")
          );

          var State = "";
          State = row.State == undefined ? "" : row.State;
          datarowv.push(State.replace(/[, ]+/g, " ").replace(/#(\S)/g, " "));

          var City = "";
          City = row.City == undefined ? "" : row.City;
          datarowv.push(
            City.replace("#", "")
              .replace("#", "")
              .replace("#", "")
              .replace(/[, ]+/g, " ")
          );

          var Zip = "";
          Zip = row.Zip == undefined ? "" : row.Zip;
          datarowv.push(
            Zip.replace("#", "")
              .replace("#", "")
              .replace("#", "")
              .replace(/[, ]+/g, " ")
          );
          //----------------------------------------------------------------------------------

          var PaymentStatus = "";
          if (row.Payment != undefined) {
            PaymentStatus =
              row.Payment.Status == undefined ? "" : row.Payment.Status;
            datarowv.push(PaymentStatus);

            var TransactionId = "";
            TransactionId =
              row.Payment.TransactionId == undefined
                ? ""
                : row.Payment.TransactionId;
            datarowv.push(TransactionId);
            var Amount = "";
            Amount = row.Payment.Amount == undefined ? "" : '"' + row.Payment.Amount + '"';
            datarowv.push(Amount);
            var dateTm = "";
            dateTm =
              row.Payment.Created == undefined
                ? ""
                :  this.SetTimeByZone(row.Payment.Created, Session_Event_TZ) ;
            datarowv.push(dateTm);
            var Source = "";
            var Source =
              row.Payment.Source == undefined ? "" : row.Payment.Source;
            datarowv.push(Source);
          }
          var RegistrationType = "";
          RegistrationType =
            row.RegistrationType == undefined ? "" : row.RegistrationType.RegistrationType;
          datarowv.push(RegistrationType);

          var PaymentRetryURL = "";
          if (PaymentStatus != "PAID") {
            PaymentRetryURL =
              customDomain +
              "/paymentstatus" +
              "/" +
              eventID +
              "/" +
              row.Email;
            //   console.log();
            //datarowv.push(PaymentRetryURL);
          }
          datarowv.push(PaymentRetryURL);
          var RSVPCode = "";
          RSVPCode = row.RSVPCode == undefined ? "" : row.RSVPCode;
          datarowv.push(RSVPCode);
          //---------------------------------------------------------------------------------

          let cellval = DynamicFieldsStartIndex;
          if (row.DynamicFields) {
            let DynamicFields = Object.values(row.DynamicFields);
            cellIndex.filter(function (cellfeild) {
              let cellvalue = "";
              DynamicFields.filter((rowf) => {
                if (
                  rowf.label.replace(/[, ]+/g, "") ==
                  cellfeild.label.replace(/[, ]+/g, "")
                ) {
                  if (Array.isArray(rowf.value)) {
                    let arr = rowf.value.map(function (s) {
                      return s.replace(/[, ]+/g, "");
                    });
                    cellvalue = arr.join("|");
                  } else {
                    cellvalue = rowf.value.replace(/#(\S)/g, " ");
                  }
                }
              });
              debugger;

              datarowv.push(cellvalue.replace(/[/ ]+/g, " "));
              cellval++;
            });
          }

          //---------------------------------------------------------

          Data.push(datarowv);
        });
        Header.push(datarowh);
        debugger;
        let csvContent = "data:text/csv;charset=utf-8,";
        var dt = new Date().toISOString().slice(0, 10);
        AttendeeData = Header.concat(Data);
        AttendeeData.forEach(function (rowArray) {
          let row = rowArray.join(",");
          csvContent += row + "\r\n";
        });
        console.log(JSON.stringify(csvContent));
        var filename = "PaidRegistrantExport_" + "_" + dt + ".csv";
        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        //link.setAttribute("id", "Participance_RT_" + row.TableId);
        link.setAttribute("download", filename);
        document.body.appendChild(link); // Required for FF

        link.click();
        //---------------------------------------------------------------
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Download Reports",
          text: "Please select atleast one attendee to download. ",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    saveSettings() {
      this.$vs.loading();
      this.$store
        .dispatch("attendeeManagement/saveSettings", {
          settingsData: this.settingsData,
        })
        .then((res) => {
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Settings",
            text: res.message,
          });
          this.$vs.loading.close();
        });
    },
    getMailTpl() {
      this.$vs.loading();
      this.popupActiveMail = true;
      this.welcomeMailText = "Loading...";
      this.$store
        .dispatch("attendeeManagement/getMailTemplate")
        .then((res) => {
          this.welcomeMailText = res.html;
          this.welcomeMailSubject = res.subject;
          this.sourcehtml = res.sourcehtml;
          this.$vs.loading.close();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getMailTplRaw() {
      this.$vs.loading();
      this.popupActiveMailUpdate = true;
      this.$store
        .dispatch("attendeeManagement/getMailTemplate")
        .then((res) => {
          this.sourcehtml = res.sourcehtml;
          this.welcomeMailSubject = res.subject;
          this.$vs.loading.close();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    changeStatus(Status) {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      if (selectedRows.length) {
        this.$vs.loading();
        this.$store
          .dispatch("attendeeManagement/changeStatus", {
            data: selectedRows,
            Status: Status,
          })
          .then((res) => {
            //alert(res.message)
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Status",
              text: res.message,
            });
            this.gridApi.deselectAll();
            this.$vs.loading.close();
            this.$store.dispatch("attendeeManagement/fetchAttendees");
          })
          .catch((err) => {
            //console.error(err)
            this.$vs.loading.close();
          });
      } else {
        this.$vs.dialog({
          type: "alert",
          position: "top-center",
          color: "warning",
          title: "Status",
          text: "Please Select a Row",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    before_save() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          this.saveMail();
        }
      });
    },
    saveMail() {
      this.$vs.loading();
      this.$store
        .dispatch("attendeeManagement/saveMail", {
          sourcehtml: this.sourcehtml,
          subject: this.welcomeMailSubject,
        })
        .then((res) => {
          //alert(res.message)
          this.$vs.notify({
            color: "success",
            title: "Mail Save",
            text: res.message,
          });
          this.$vs.loading.close();
        })
        .catch((err) => {
          //console.error(err)
          this.$vs.loading.close();
        });
    },
    sendMail() {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      //console.log(selectedRows);
      ///than you can map your selectedRows
      selectedRows.map((row) => {
        //console.log(row);
        this.mailRecepients.push(row.AttendeeId);
      });
      if (this.mailRecepients.length && this.welcomeMailSubject) {
        this.$vs.loading();
        this.$store
          .dispatch("attendeeManagement/sendMail", {
            data: this.mailRecepients,
            subject: this.welcomeMailSubject,
          })
          .then((res) => {
            //alert(res.message)
            this.$vs.notify({
              color: "success",
              title: "Mail Sent",
              text: res.message,
            });
            this.mailRecepients = [];
            this.gridApi.deselectAll();
            this.$vs.loading.close();
          })
          .catch((err) => {
            //console.error(err)
            this.$vs.loading.close();
          });
      } else {
        //alert("Please Select Recepient!");
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Recepient",
          text: "Please Select Recepient! ",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
      this.popupActiveMail = false;
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== "all") {
        modelObj = { type: "equals", filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();

      // Reset Filter Options
      this.roleFilter =
        this.statusFilter =
        this.isVerifiedFilter =
        this.departmentFilter =
          {
            label: "All",
            value: "all",
          };

      this.$refs.filterCard.removeRefreshAnimation();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    addRecord() {
      this.$router.push("/event/attendee/add").catch(() => {});
    },
    deleteRecord() {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      if (selectedRows.length) {
        this.$vs.dialog({
          type: "confirm",
          color: "danger",
          title: "Confirm Delete",
          text: `You are about to delete`,
          accept: this.deleteRecords,
          acceptText: "Delete",
        });
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Recepient",
          text: "Please Select Record!",
          acceptText: "OK",
        });
      }
    },
    deleteRecords() {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      this.$vs.loading();
      this.$store
        .dispatch("attendeeManagement/removeMultiRecords", {
          data: selectedRows,
        })
        .then((res) => {
          //alert(res.message)
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Delete",
            text: res.message,
          });
          this.gridApi.deselectAll();
          this.$vs.loading.close();
          this.$store.dispatch("attendeeManagement/fetchAttendees");
        })
        .catch((err) => {
          //console.error(err)
          this.$vs.loading.close();
        });
    },
    UploadAttendee: function () {
      var files = document.getElementById("attendee_file").files;
      bu.initVueComps(this.$vs);
      bu.StartUploadPrecss(files, "attendee");
    },
  },
  mounted() {
    //vm.Session_Client_Id = ls.getSessionValueByKey("Session_Client_Id");
    // var customDomain = ls.getSessionValueByKey("CustomDomain");
    // customDomain = "https://" + ls.getSessionValueByKey("CustomDomain");
    // alert(customDomain);
    // if (customDomain != null) {
    //   vm.CustomDomain = "https://" + ls.getSessionValueByKey("CustomDomain");
    // } else {
    //   vm.CustomDomain = "";
    // }
    this.gridOptions.api.showLoadingOverlay();
    this.gridApi = this.gridOptions.api;

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
  },
  created() {
    /*if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }
    this.$store.dispatch('userManagement/fetchUsers').catch(err => { console.error(err) })*/

    if (!moduleAttendeeManagement.isRegistered) {
      this.$store.registerModule(
        "attendeeManagement",
        moduleAttendeeManagement
      );
      moduleAttendeeManagement.isRegistered = true;
    } /*else {
      this.$store
        .dispatch("attendeeManagement/reInitAttendeeSession")
        .then(res => {})
        .catch(err => {
          alert("Something went wrong!");
        });
    }*/
    this.$store
      .dispatch("attendeeManagement/fetchAttendeesPaidReg")
      .then((res) => {
        res.map((row) => {
          this.totalAmount =
            this.totalAmount +
            (row.Payment && row.Payment.Amount
              ? Number(row.Payment.Amount.replace("$", "").replace("€", ""))
              : 0);
        });
      })
      .catch((err) => {
        //console.error(err)
      });

    /*let html = "Subject: BNI Cochin Welcomes You to Celebrate Regional Awards & Business Conclave 2020!";
    html += "\n\nHi @@attendee@@, \n\nYou are successfully registered to the Regional Awards & Business Conclave 2020 by BNI Cochin. \nBelow is the link and credentials to login:";
    html += "\n\nLogin URL: https://bni.e2m.live/  \n\nUsername: Registered Email Address \nPin: @@UserPin@@ ";
    html += "\n\nSee you at the Conclave!";
    html +="\n\nThank you,\nTeam e2m OnAir";
    html += "\n\nThis is an auto-generated e-mail. Please do not reply to this e-mail. For any queries or help, please e-mail to support@e2m.live";
    this.welcomeMailText = html;*/
  },
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>